module.exports = __webpack_public_path__ + "img/logo.bd8cf246.png";